import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { UnitOfMeasureListing, UnitOfMeasureSummary } from '~/models/modules/unitOfMeasure';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class UnitOfMeasuresService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }
  UOMAdded: EventEmitter<any> = new EventEmitter();
  UOMUpdated: EventEmitter<any> = new EventEmitter();
  getUnitOfMeasure(id: number) {
    return this.http.get<UnitOfMeasureSummary>(this._url(`/${id}`));
  }

  getUnitOfMeasures(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<UnitOfMeasureSummary[]>(this._url(`/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  getAccountUnitOfMeasures(accountIds: any[] | any, model: any = {}) {
    if (Array.isArray(accountIds)) {
      model = { ...model, accountIds };
    } else if (accountIds && typeof accountIds === 'object' && 'accountIds' in accountIds) {
      model = accountIds;
    } else {
      model = { ...model, accountIds: accountIds ? [accountIds] : [] };
    }
    return this.http.post<UnitOfMeasureListing[]>(this._url(`/accounts`), model);
  }

  createUnitOfMeasure(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  updateUnitOfMeasure(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  deleteUnitOfMeasure(id: number) {
    return this.client.delete(this._url(`/${id}`));
  }
  deactivateUnitOfMeasure(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }
  deactivateUnitOfMeasureBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
}
  reactivateUnitOfMeasure(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }
  reactivateBatchUnitOfMeasure(obj: any) {
    return this.client.put(this._url(`/reactivate-batch`), obj);
  }

  getStockRecievePerDate(id: number) {
    return this.client.get(this._url(`/recieve-per-date/${id}`));
  }

  getStockIssuePerDate(id: number) {
    return this.client.get(this._url(`/issue-per-date/${id}`));
  }

  getStockInventoryPerDate(id: number) {
    return this.client.get(this._url(`/inventory-per-date/${id}`));
  }


  GetUnitOfMeasureChart(unitOfMeasureId : number){
    return this.client.get(this._url(`/UnitOfMeasures/${unitOfMeasureId}/UnitOfMeasureChart`))
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/UnitOfMeasures${v}`);
  }
}
